import { Col, Row } from '@dec/shared';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { ReportForm } from '../../components/ReportForm';
import { useReport } from '../../services/hooks';
import { title } from '../../translation';

import Version from './Version';

interface EditReport {
  id?: string;
}

export const EditReport = (props: EditReport) => {
  const { t, i18n } = useTranslation();
  const params = useParams<Record<string, string>>();
  const id = props.id ?? params.id ?? '';
  const { data } = useReport(id);

  return (
    <>
      <Row>
        <Col xl={8} md={8} lg={8}>
          <h1 className="mt-2">{title(t, 'report')}</h1>
          {data && <ReportForm defaultValue={data} />}
        </Col>
        <Col xl={4} md={4} lg={4}>
          <h1 className="mt-2">{title(t, 'versions')}</h1>
          <Version reportId={id} />
        </Col>
      </Row>
    </>
  );
};
